import { IFonts } from './IFonts';

export const fonts: IFonts = {
  primary: 'Open Sans',
};
